import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppFooter } from './app-footer.component';

@NgModule({
  declarations: [
    AppFooter
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    AppFooter
  ]
})
export class AppFooterModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-footer/app-footer.module.ts